import { Toast } from './toast';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts, removeToast } = useToast();
  
  return (
    <div className="fixed top-0 right-0 z-[1000] flex flex-col gap-2 w-full max-w-md p-4">
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          title={toast.title}
          description={toast.description}
          action={toast.action}
          onClose={() => removeToast(toast.id)}
          className="transition-opacity animate-in fade-in-75 duration-300"
        />
      ))}
    </div>
  );
} 